/* eslint-disable react/no-array-index-key */
import styled, { css, ThemeProvider } from "styled-components";
import React from "react";
import AspectRatio from "../AspectRatio";
import ConditionalWrapper from "../ConditionalWrapper";
import { rem } from "../../utils";
import DefaultLinkRenderer from "../DefaultLinkRenderer";
import { Button } from "../Button";
import { Colors, mediaQueries } from "../../styles";
export const StyledCard = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  color: ${Colors.BLACK};
  background: ${Colors.WHITE};
  border: 1px solid ${Colors.GRAY};
  border-radius: 5px;
  box-sizing: border-box;

  flex: 1;

  /* aspect ratio image rounded image to follow corners of top left/right. */
  overflow-x: hidden;
  position: relative;

  ${(props) => props.isCardClickable &&
    css `
      cursor: pointer;

      &:hover,
      &:focus-within {
        border-color: ${Colors.BLACK};
      }
    `}

  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
    flex-direction: row;
    overflow-x: visible;
    align-items: stretch;
  `}
`;
const StyledContent = styled.div `
  padding: ${rem(20)};

  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
      padding: ${rem(24)} ${rem(16)} ${rem(18)};
  `}
`;
const Title = styled.h3 `
  font-size: ${rem(20)};
  line-height: ${rem(24)};
  margin: 0 0 ${rem(8)};
  font-weight: 500;
`;
const ImageTools = styled.div `
  z-index: 1;
  position: absolute;
  bottom: ${rem(-20)};
  right: ${rem(20)};
  display: flex;
  > * {
    margin-left: ${rem(16)};
  }
  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
    display: none;
  `}
`;
const ImageBox = styled.div `
  position: relative;
  width: 100%;
  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
      display: flex;
      max-width: ${rem(262)};
  `}
`;
const Image = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const CardLink = styled.a `
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
`;
const ImageRenderer = (image) => (React.createElement(Image, { ...image }));
const LineImageWrapper = styled.div `
  display: none;

  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
    display: block;
  `}
`;
const DefaultImageWrapper = styled.div `
  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
    display: none;
  `}
`;
const ContentActionButtons = styled.div `
  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
      display: flex;
      justify-content: flex-end;
      > *:first-child {
        margin-right: ${rem(16)};
      }
  `}
`;
const ContentActionTools = styled.div `
  display: none;
  ${({ theme }) => theme.variant === "line" &&
    mediaQueries.up("medium") `
      display: flex;
      > *:not(:last-child) {
        margin-right: ${rem(16)};
      }
  `}
`;
export const InteractiveCard = ({ children, title, href, description, tools, image, onClick, variant, imageRatio = 318 / 176, linkRenderer = DefaultLinkRenderer, renderImage = ImageRenderer, hrefButtonTitle = "Read more", isCardClickable = true, }) => {
    const showReadMoreButton = !!href || !!onClick;
    const cardClickCondition = showReadMoreButton && isCardClickable;
    const Link = linkRenderer;
    return (React.createElement(ThemeProvider, { theme: { variant } },
        React.createElement(StyledCard, { isCardClickable: cardClickCondition },
            React.createElement(ImageBox, null,
                image && (React.createElement(React.Fragment, null,
                    React.createElement(LineImageWrapper, null, renderImage(image)),
                    React.createElement(DefaultImageWrapper, null,
                        React.createElement(AspectRatio, { ratio: imageRatio }, renderImage(image))))),
                tools && (React.createElement(ImageTools, null, tools.map((toolObj, index) => (React.createElement(Button, { key: index, theme: "ghost", onClick: (event) => {
                        event.stopPropagation();
                        toolObj.onClick(event);
                    }, leadingIcon: toolObj.icon, title: toolObj.title })))))),
            React.createElement(StyledContent, null,
                React.createElement("div", null,
                    title && (React.createElement(ConditionalWrapper, { condition: cardClickCondition, wrapper: (conditionalChildren) => (React.createElement(Link, { onClick: onClick, AnchorElement: CardLink, href: href }, conditionalChildren)) },
                        React.createElement(Title, null, title))),
                    description && React.createElement("div", null, description)),
                children,
                showReadMoreButton && (React.createElement(ContentActionButtons, null,
                    React.createElement(Button, { onClick: onClick, style: { position: "relative" }, size: "medium", href: href }, hrefButtonTitle),
                    tools && (React.createElement(ContentActionTools, null, tools.map((toolObj, index) => (React.createElement(Button, { key: index, theme: "ghost", onClick: (event) => {
                            event.stopPropagation();
                            toolObj.onClick(event);
                        }, leadingIcon: toolObj.icon, title: toolObj.title })))))))))));
};
export default InteractiveCard;
//# sourceMappingURL=InteractiveCard.js.map